document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector("[data-header]");
  if (header) {
    window.addEventListener("scroll", () => {
      header.classList.toggle("is-scrolled", window.scrollY > 24);
    });
  }

  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add("is-visible");
      });
    },
    { threshold: 0.18 }
  );

  document.querySelectorAll(".section-reveal").forEach((section) => revealObserver.observe(section));
});
